import React, { Component } from "react";
import Apihelpers from './../helper/ApiHelper';
import $ from "jquery";
import {POST_MASTER_SERVICE_CREATE, MASTER_SERVICE_CAT} from './../helper/Constants';


export default class SourceCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createRecord: {
        sr: props.lastSequence,
        key: "",
        name: "",
        type:"",
        price:0,
        status:true,
        token:'',
        url:'',
        email:'',
        curl:'',
        contactNo:''
      },
      types:props.plans || []
    }
  }
  componentDidMount() {
    $("#multiSelect").select2({
      placeholder: "select plans",
      tags: false,
      //tokenSeparators: [',', ' ']
    });
  }

  formSubmitFun = (e) => {
    e.preventDefault();
    if(!this.state.createRecord.key.replace(/\s+/g, '')) {
      alert('Please add valid key');
      return;
    }
    let types = $("#multiSelect").select2("val");
    console.log('types',types);
    const formData = {
      "sequence": this.state.createRecord.sr,
      "source_key": this.state.createRecord.key,
      "vendor_name": this.state.createRecord.name,
      "plan_type": types.map(Number),
      "price":this.state.createRecord.price,
      "status":this.state.createRecord.status,
      "token": this.state.createRecord.token,
      "api_url": this.state.createRecord.url,
    }
    if(this.state.createRecord.email !== '') {
      formData['email'] = this.state.createRecord.email
    }
    if(this.state.createRecord.url !== '') {
      formData['curl'] = this.state.createRecord.curl
    }
    if(this.state.createRecord.contactNo !== '') {
      formData['contact_no'] = this.state.createRecord.contactNo
    }
    //JSON.stringify()
    
    
    console.log('call api....');
    console.log('formData',formData);
   // return;
    this.props.toggleLoader();
    Apihelpers.postdataresponse('allsources/source-create', formData)
      .then((res) => {
        console.log('res', res.data);
        if (res.data.status === true) {
          this.props.togglePopUp();
          this.props.loadPlanes();
        } else {
          console.log('coming validation error');
          this.setState({
            createRecord: { ...this.state.createRecord, validationError: res.data.message }
          })
          this.props.toggleLoader();
        }
      }).catch((error) => {
        console.log('error', error);
      });
  }


  render() {
    return (
      <div className="customPopup" style={{ 'display': 'block' }}>
        <div className="bgLayer" />
        <div className="popUpBox" style={{ maxWidth: "770px" }}>
          <span className="closeIcon" onClick={this.props.togglePopUp}> </span>
          <div className="popScroll" style={{ padding: "20px 25px 16px 25px" }}>
            {
              //JSON.stringify(this.state.createRecord, null, 2)
            }
            <div className="popUpHed">
              <h3>Create New Source</h3>
              {/* <div className="desc">Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.</div> */}
            </div>
            <form className="form" method="post" onSubmit={this.formSubmitFun}>
              <div className="row">
                <div className="col-md-2">
                  <div className="form-group">
                    <label className="control-title">Sequence No.<span className="ex">*</span></label>
                    <input type="number" className="form-control" required readOnly defaultValue={this.state.createRecord.sr} onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "sr": e.target.value } })
                    }} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-title">Source Key <span className="ex">*</span></label>
                    <input type="text" className="form-control" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "key": e.target.value } })
                    }} placeholder="enter plan key" pattern="^\S+$" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Vendor Name <span className="ex">*</span></label>
                    <input type="text" className="form-control" placeholder="enter plan name" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "name": e.target.value } })
                    }} />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label className="control-title">Price <span className="ex">*</span></label>
                    <input type="number" className="form-control" placeholder="price" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "price": e.target.value } })
                    }} defaultValue={0} min="0" max="99" />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="control-title">Status <span className="ex">*</span></label>
                    <select className="form-control" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "status": (e.target.value === 'Active') ? true : false } })
                    }}>
                      <option>Active</option>
                      <option>InActive</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Plans Type <span className="ex">*</span></label>
                    <select className="form-control" required multiple="multiple" id="multiSelect" style={{ width: "100%" }}>
                      {
                        this.state.types.map((itm)=>{
                          return(<option key={itm.sr} value={itm.sr}>{itm.key}</option>)
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Token <span className="ex">*</span></label>
                    <input type="text" className="form-control" placeholder="enter token" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "token": e.target.value } })
                    }} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">URL <span className="ex">*</span></label>
                    <input type="text" className="form-control" placeholder="enter url" required onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "url": e.target.value } })
                    }} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Email </label>
                    <input type="text" className="form-control" placeholder="enter email"  onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "email": e.target.value } })
                    }} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-title">Contact Number</label>
                    <input className="form-control" placeholder="enter contact info"  onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "contactNo": e.target.value } })
                    }}></input>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-title">CURL </label>
                    <textarea className="form-control" placeholder="enter curl code" onChange={(e) => {
                      this.setState({ createRecord: { ...this.state.createRecord, "curl": e.target.value } })
                    }}></textarea>
                  </div>
                </div>

              </div>
              {
                (this.state.createRecord.validationError !== "") ?
                  <div className="error-msg">{this.state.createRecord.validationError}</div>
                  : ""
              }
              <div className="submitRow">
                <button className="backBtn" type="button" onClick={this.props.togglePopUp}>Cancel</button>
                <button className="blueBtn" type="submit">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}